import React from "react";

import { Create, SimpleForm } from 'react-admin';

import { AppManagerRoles, UserRole } from '../../../entities';

import { SaveWithCancelToolbar } from '../../../components/toolbars/SaveWithCancelToolbar';
import { TaskDisplayActionForm } from "../Form/TaskDisplayActionForm";
import { isInArray } from "../../../utils/general";


export const TaskDisplayActionCreate = ({permissions, ...props}) => {
	const isAdminOrOSFCManager = permissions && isInArray(AppManagerRoles, permissions.role);

	return (
		<Create {...props}>
			<SimpleForm submitOnEnter={false} toolbar={<SaveWithCancelToolbar />} redirect="list">
				<TaskDisplayActionForm  />
			</SimpleForm>
		</Create>
	);
};